// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kZYWp{display:none}@media(max-width: 768px){.kZYWp{display:block;width:180px;height:auto;margin:0 auto 20px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileLogo": `kZYWp`
};
module.exports = ___CSS_LOADER_EXPORT___;
